import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// components
import { CloseButton } from './..'

// hooks
import { useIsExtension } from '../../hooks/utility'

import styles from './Popup.module.scss'

const Popup = ({ onClose, children }) => {
  const isChromeExtension = useIsExtension()

  return (
    <div className={styles.popupContainer}>
      <CloseButton className={styles.close} onClick={onClose} />
      <div
        className={classnames(styles.overlay, {
          [styles.overlayExtension]: isChromeExtension,
        })}
      >
        {children}
      </div>
    </div>
  )
}

Popup.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
  ]),
}

export default Popup
